<template>
<!-- eslint-disable max-len -->
<list-page
  name="Coupon"
  plural="Coupons"
  use="_id"
  :display="display"
  page-prefix="/blade/coupons"
  :fetch="getCoupons"
  :remove="deleteCoupon"
  :sort-options="sortOptions"
  :sort-functions="sortFunctions"
  :default-sort="defaultSort"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      sortOptions: [
        'Last Updated',
      ],
      sortFunctions: [
        this.lastUpdatedSort,
      ],
      defaultSort: 0,
    };
  },
  methods: {
    ...mapActions([
      'getCoupons',
      'deleteCoupon',
    ]),
    display(argument) {
      const {
        name: couponName, description, code, updated
      } = argument;
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${couponName} (${code})\n ${description} ${dateString}`;
    },
    lastUpdatedSort(a, b) {
      if (a.updated == null && b.updated == null) return 0;
      if (a.updated == null) return 1;
      if (b.updated == null) return -1;
      return (a.updated > b.updated) ? -1 : ((a.updated < b.updated) ? 1 : 0);
    },
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/CouponList.vue